import { gql } from '@apollo/client';
import BaseService from './baseService';

class ContactTypesService extends BaseService {
  constructor() {
    super();
    this.contactTypeGql = `
      contactTypeId
      contactType
    `;
  }

  getContactTypes = () => new Promise((resolve, reject) => {
    const CONTACT_TYPES = gql`
      query {
        dispatchContactTypes{
            ${this.contactTypeGql}
        }
      }
    `;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: CONTACT_TYPES
      })
      .then((result) => {
        if (result.data.dispatchContactTypes) {
          resolve(result.data.dispatchContactTypes);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });
}

const contactTypesService = new ContactTypesService();

export default contactTypesService;
